import { ReactNode, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useIsMobile } from "@/shared/adaptive/use-is-mobile";

const SIDEBAR_PORTAL = "sidebar-portal";
const WIDTH = 320;

export function PortalAside() {
  return (
    <aside
      id={SIDEBAR_PORTAL}
      className="empty:hidden hidden xl:gap-4 xl:grid max-h-[--aside-height] overflow-y-auto"
    />
  );
}

export function InSidebar({
  children,
  condition,
  mobileFlow,
}: {
  children: ReactNode;
  condition?: boolean;
  mobileFlow?: boolean;
}) {
  const [mountNode, setMountNode] = useState<HTMLElement | null>(null);
  const isMobile = useIsMobile();

  useLayoutEffect(() => {
    setMountNode(document.getElementById(SIDEBAR_PORTAL));
  }, []);

  if (condition === false) {
    return null;
  }

  if (mobileFlow && isMobile && children) {
    return children;
  }

  if (children && mountNode) {
    return createPortal(<Container>{children}</Container>, mountNode);
  }

  return null;
}

function Container({ children }: { children: ReactNode }) {
  return <div className={`w-[${WIDTH}px] grid gap-y-5`}>{children}</div>;
}

export function StickyElement({ children }: { children: ReactNode }) {
  return (
    <div className="sticky top-[calc(var(--header-height)_+_var(--header-indent))]">
      {children}
    </div>
  );
}
